import React, { createContext } from 'react';
import { Animation } from './styles';

type AnimationData = Record<string, unknown>;

export const AnimationContext = createContext<AnimationData>(
  {} as AnimationData,
);

export const AnimationProvider: React.FC = ({ children }) => {
  return (
    <AnimationContext.Provider value={{}}>
      <Animation>{children}</Animation>
    </AnimationContext.Provider>
  );
};
